<template>
    <div>
        <loading :active.sync="loading" 
                color= '#007bff'
                :width= '128'
                :height= '128'
                loader='dots'
                :can-cancel="true" 
                :is-full-page="true">
            </loading>
        <b-row>
            <b-col cols="12">
                <card>
                    <b-row class="mb-4">
                        <b-col lg="12">
                            <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                            <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event)" :lookupId="priceSetup.product_code"/>
                        </b-col>
                    </b-row>

                    <b-row>

                        <b-col lg="2">
                            <base-input :label="language_terms['UNIT_PRICE']" v-model="priceSetup.unit_price" type="number" :min="0">
                            </base-input>
                        </b-col>
                        <b-col lg="3">
                            <base-input :label="language_terms['MIN_QTY']" v-model="priceSetup.min_qty" type="number" :min="0">
                            </base-input>
                        </b-col>
                        <b-col lg="3">
                            <base-input :label="language_terms['DATE_FROM']">
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="priceSetup.date_from">
                                </flat-picker>
                            </base-input>
                        </b-col>
                        <b-col lg="3" >
                            <base-input :label="language_terms['DATE_TO']" >
                                <flat-picker
                                    slot-scope="{ focus, blur }"
                                    @on-open="focus"
                                    @on-close="blur"
                                    style="background-color: white"
                                    class="form-control datepicker"
                                    v-model="priceSetup.date_to">
                                </flat-picker>
                            </base-input>
                        </b-col>
                        <b-col lg="1" class='mt-4'>
                            <base-button  type="primary" class='mt-2' @click.native="addPrice">
                                <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                            </base-button>
                        </b-col>
                    </b-row>
                </card>
                <card v-if="priceItems.length > 0">
                    <b-row>
                        <b-col lg="12">
                            <b-table-simple striped hover responsive>
                                <b-thead head-variant="light">
                                    <b-th>{{language_terms['PRODUCT_CODE']}}</b-th>
                                    <b-th>{{language_terms['PRODUCT_NAME']}}</b-th>
                                    <b-th>{{language_terms['UNIT_PRICE']}}</b-th>
                                    <b-th>{{language_terms['MIN_QTY']}}</b-th>
                                    <b-th>{{language_terms['DATE_FROM']}}</b-th>
                                    <b-th>{{language_terms['DATE_TO']}}</b-th>
                                    <b-th></b-th>
                                </b-thead>
                                <b-tbody>
                                    <tr v-for="(item, j) in priceItems" :key="j">
                                        <td>{{item.product_code}}</td>
                                        <td>{{item.product_name}}</td>
                                        <td>{{item.unit_price}}</td>
                                        <td>{{item.min_qty}}</td>
                                        <td>{{displayDate(item.date_from)}}</td>
                                        <td>{{displayDate(item.date_to)}}</td>
                                        <td>
                                            <base-button type="warning" @click.native="handleDeletePrice(item)" size="sm">
                                                <i class="fa fa-trash"></i>
                                            </base-button>
                                        </td>
                                    </tr>
                                </b-tbody>
                            </b-table-simple>
                        </b-col>
                    </b-row>
           
                        <!-- <b-table striped hover :items="priceItems" :fields="fields">
                             <template #cell(action)="row">
                                <base-button type="warning" @click="handleDeletePrice(row.index)" size="sm">
                                    <i class="fa fa-trash"></i>
                                </base-button>
                            </template>
                        </b-table> -->
                </card>
                <!-- <div>
                    <a href="javascript:void(0)" class="float-button mr-2" @click="handelSave" style="background-color:#5e72e4">
                        <i class="fas fa-check my-float-button"></i>
                    </a>
                </div> -->
            </b-col>
        </b-row>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { mapState } from "vuex";
import {Table,TableColumn,Button,Select, Option} from 'element-ui'
import Multiselect from 'vue-multiselect'
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import BaseButton from '../../components/BaseButton.vue';
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";


import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import productLookup from "@/components/Autocomplete.vue";

export default {
    props:{
        module:{
            type: String,
            required:true,
            default:null
        },
        contact_id:
        {
            default:-1,
            required:false,
        },
        code:{
            default:null,
            required:true,
        },
        customized_prices:{
            type: Array,
            default: function () { return [] },
            required:true,
        }
    },
    data(){
        return{
            apiProductLookup: apiRoutes["PRODUCT_LOOKUP"],
            fields: ['type', 'code', 'name','date_from','date_to','default_discount','moq_discount','action'],
            priceItems: [],
            loading:false,
            activeOptions:[
            {
                value: "product_category",
                label: "PRODUCT_CATEGORY",
            },
            {
                value: "product",
                label: "PRODUCT",
            },

            ],
            priceSetup:
            {
                date_from:"",
                date_to:"",
                product:{},
                min_qty:'',
                unit_price:null,
                product_code:'',
                product_id:'',
                product_name:'',
            },
            products:[],
            productCategories:[],
            customers:[]
            }

    },
    computed:{
         ...mapState({
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
            is_purchase_price_created: state => state.purchasePrice.is_created,
            is_deleted:state => state.purchasePrice.is_deleted
         })
    },
     components: {
        productLookup,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        Multiselect,
        BaseButton,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button,
        Loading

  },
  watch:{
      customized_prices:{
          deep: true,
           handler(){
                this.priceItems = this.customized_prices
            }
      }
  },
mounted()
  {
    this.priceItems = this.customized_prices
  },
  methods:{
        selectProduct(obj)
        {
            if(obj)
            {
                this.priceSetup.product_id = obj.id
                this.priceSetup.product_code = obj.code
                this.priceSetup.product_name = obj.name

            }
        },
        displayDate(date)
        {
            let d = '-';
            
            if(date)
                d = moment(date).format("DD/MM/YYYY");

            return d;
        },
        customerNameWithCode ({ name, code }) {
            if(name || code)
                return `${name} (${code})`
        },
        async handleDeletePrice(item){

            if(item.id)
            {
                await this.$store.dispatch("purchasePrice/delete", {id:item.id})
                if(this.is_deleted)
                {
                    this.loading = true
                    await this.$store.dispatch("vendors/fetch", {code:this.code});                    
                    this.loading = false
                }
            }
        },
        categoryNameWithCode ({ name, code }) 
        {
            if(name || code)
                return `${name} (${code})`
        },
        productNameWithCode ({ name, code }) 
        {
            if(name || code)
                return `${name} (${code})`
        },
        async addPrice()
        {
            this.loading = true

            this.priceSetup.contact_id = this.contact_id
            await this.$store.dispatch("purchasePrice/create", this.priceSetup);

            if(this.is_purchase_price_created == '1')
            {
                await this.$store.dispatch("vendors/fetch", {code:this.code});   
                
                this.priceSetup = {
                        min_qty:null,
                        unit_price:null,
                        date_from:null,
                        date_to:null,
                        product:{},
                        product_code:null,
                        product_id:null,
                        product_name:null
                    }
            }

            this.loading = false

        }
  }

}
</script>

<style>

</style>